import {Component, EventEmitter, Input, Output} from "@angular/core";
import {InstallType, InstallTypePastTense} from "../../../../services/dtos/enums/install-type.enum";
import {TreeNode} from "../../../../services/dtos/interfaces/tree-node";
import {DeploymentTreeComponent} from "../../../deployment/deployment-tree/deployment-tree.component";
import {DeploymentUtilitiesService} from "../../../../services/deployment-utilities.service";

@Component({
    selector: 'deployment-batch-preview',
    template: require('./deployment-batch-preview.component.html'),
    styles: [ require('./deployment-batch-preview.component.css') ]
})
export class DeploymentBatchPreviewComponent {
    @Input() installType: InstallType;
    @Input() rootNode: TreeNode;
    @Input() version: string;

    @Input() includeDeployments: boolean;
    @Output() includeDeploymentsChange = new EventEmitter<boolean>();

    constructor(protected deploymentUtilitiesService: DeploymentUtilitiesService) {
    }

    getInstallTypeTitle(installType: InstallType) : string {
        let count = this.deploymentUtilitiesService.getApplicationsForNode(this.rootNode, true, installType, this.version).length;
        return `<strong>${count} application${count == 1 ? '' : 's'}</strong> will be <strong>${InstallTypePastTense.get(installType)}</strong>`;
    }

    getInstallTypeClass(installType: InstallType) : string {
        if (installType == InstallType.Downgrade)
            return "applications-downgrading";

        if (installType == InstallType.Reinstall)
            return "applications-reinstalling";

        if (installType == InstallType.Upgrade)
            return "applications-upgrading";

        return "";
    }

    updateIncludeDeployments(value: boolean) : void {
        this.includeDeployments = value;
        this.includeDeploymentsChange.emit(value);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/modals/deployment-confirmation/deployment-batch-preview/deployment-batch-preview.component.ts